var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-lg-none" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isCollapsed,
            expression: "isCollapsed"
          }
        ],
        staticClass:
          "view-option-collapse-button view-options-color btn bg-white",
        attrs: { type: "button", "aria-label": "toggle navigation side panel" },
        on: { click: _vm.toggleCollapse }
      },
      [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$resourceString["product.Details.Label.ViewOptions"])
          )
        ]),
        _vm._v(" "),
        _c("span", {
          staticClass: "png-icon mx-2",
          class: _vm.isCollapsed
            ? "png-icon-icons-glyph--g-mobile-menu"
            : "png-icon-icons-glyph--g-close"
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "bg-white view-options-color collapse view-option-collapse-button-expand container",
        class: { show: !_vm.isCollapsed },
        attrs: { id: "view-options-collapse" }
      },
      [
        _c(
          "button",
          {
            staticClass: "btn justify-content-end w-100 p-0 view-options-color",
            attrs: { type: "button" },
            on: { click: _vm.toggleCollapse }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString["product.Details.Label.ViewOptions"]
                ) +
                "\n      "
            ),
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--g-close mx-2"
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-3 text-capitalize" },
          [
            _c("h6", [
              _vm._v(
                _vm._s(_vm.$resourceString["product.Details.Label.ViewOptions"])
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.filteredViewOptions, function(option, index) {
              return _c(
                "label",
                {
                  key: index,
                  staticClass: "custom-control custom-radio mr-4 cursor-pointer"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedViewOption,
                        expression: "selectedViewOption"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      id: "" + option.value,
                      name: option.name
                    },
                    domProps: {
                      value: option.value,
                      checked: _vm._q(_vm.selectedViewOption, option.value)
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedViewOption = option.value
                        },
                        _vm.emitViewOptionChange
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control-label" }, [
                    _c(
                      "div",
                      { staticClass: "align-items-center d-flex font-size-18" },
                      [_c("span", [_vm._v(_vm._s(option.label))])]
                    )
                  ])
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-3 text-capitalize mt-4" },
          [
            _c("h6", [
              _vm._v(
                _vm._s(
                  _vm.$resourceString[
                    "product.Details.Label.ViewOptions.InstallationMethod"
                  ]
                )
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.installationMethods, function(option, index) {
              return _c(
                "label",
                {
                  key: index,
                  staticClass: "custom-control custom-radio mr-4 cursor-pointer"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedInstallOption,
                        expression: "selectedInstallOption"
                      }
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      id: "" + option.tricycleCode,
                      name: option.name
                    },
                    domProps: {
                      value: option.tricycleCode || option.code,
                      checked: _vm._q(
                        _vm.selectedInstallOption,
                        option.tricycleCode || option.code
                      )
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedInstallOption =
                            option.tricycleCode || option.code
                        },
                        function($event) {
                          return _vm.emitInstallOptionChange(option)
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-control-label" }, [
                    _c(
                      "div",
                      { staticClass: "align-items-center d-flex font-size-18" },
                      [_c("span", [_vm._v(_vm._s(option.name))])]
                    )
                  ])
                ]
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }